
import {
  computed, defineComponent, PropType, toRefs,
} from 'vue-demi';
import './typography.scss';
import { typographyVariantType } from './options';
import { colorTypographyTokenType } from '../AdmColors/colors';

export default defineComponent({
  name: 'adm-typography',
  props: {
    variant: {
      type: String as PropType<typographyVariantType>,
      default: 'bodyM',
    },
    tag: {
      type: String,
      default: null,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String as PropType<colorTypographyTokenType>,
      default: 'primary',
    },
  },
  setup(props) {
    const {
      color, tag, variant, bold, uppercase,
    } = toRefs(props);

    const tagName = computed(() => {
      if (tag.value) {
        return tag.value;
      }

      if (['bodyL', 'bodyM'].indexOf(variant.value) !== -1) {
        return 'p';
      }

      if (['h1', 'h2', 'h3', 'h4', 'h5'].indexOf(variant.value) !== -1) {
        return variant.value;
      }

      return 'div';
    });

    const classes = computed(() => [
      'adm-typography',
      `adm-typography--${variant.value}`,
      `adm-text--${color.value}`,
      {
        'adm-typography--bold': bold.value,
        'adm-typography--uppercase': uppercase.value,
      },
    ]);

    return {
      classes,
      tagName,
    };
  },
});
